import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-firstlife-layout',
  templateUrl: './firstlife-layout.component.html',
  styleUrls: ['./firstlife-layout.component.scss']
})
export class FirstlifeLayoutComponent implements OnInit {

  index = environment.FIRST_LIFE_INSURANCE_INDEX_URL;

  constructor(private baseService: BaseService) { }

  ngOnInit(): void {
    this.baseService.info.indexUrl = this.index;
  }

}
